import { For, type JSX } from "solid-js";
import type { AuthUser } from "~/features/auth/auth";
import { StreetIcon } from "~/ui/Icon";
import { studentClassLabel, type StudentClass } from "./student";

export type StudentView = "home" | "monster" | "voting" | "propose" | "feedback" | "progress" | "join" | "checkin" | "task-selection" | "mood-update" | "my-class";

const navigation: Array<{ view: StudentView; icon: string; label: string }> = [
  { view: "home", icon: "home", label: "Zuhause" },
  { view: "my-class", icon: "people", label: "Meine Klasse" },
  { view: "monster", icon: "smiley", label: "Mein Monster" },
  { view: "voting", icon: "clipboard-check", label: "Abstimmung" },
  { view: "propose", icon: "lightbulb", label: "Ziel vorschlagen" },
  { view: "feedback", icon: "speech-heart", label: "Feedback" }
];

export function StudentShell(props: {
  user: AuthUser;
  selectedClass?: StudentClass;
  view: StudentView;
  sidebarOpen: boolean;
  onSidebarOpenChange: (open: boolean) => void;
  onNavigate: (view: StudentView) => void;
  onHelp: () => void;
  onLogout: () => void;
  children: JSX.Element;
}) {
  const navigate = (view: StudentView) => {
    props.onNavigate(view);
    props.onSidebarOpenChange(false);
  };

  return (
    <>
      <div class={`sidebar-backdrop ${props.sidebarOpen ? "visible" : ""}`} onClick={() => props.onSidebarOpenChange(false)} />
      <button class="menu-toggle" type="button" onClick={() => props.onSidebarOpenChange(!props.sidebarOpen)} style={{ opacity: props.sidebarOpen ? 0 : undefined }}>☰</button>
      <div class="app-container">
        <aside class={`sidebar ${props.sidebarOpen ? "open" : ""}`} id="sidebar">
          <div class="logo"><div class="logo-icon"><img src="/img/monster-badge.png" alt="Reflexo Monster" /></div><div><div class="logo-text">Refle<span class="logo-text-pop">xo</span></div><div class="logo-version">Schüler</div></div></div>
          <div><div class="nav-label">Meine Klasse</div><div><div style={{ padding: "2px 8px 10px", "font-size": "0.8rem", "font-weight": 700, color: "rgba(255,255,255,0.75)", overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }}>{studentClassLabel(props.selectedClass)}</div></div></div>
          <div class="nav-section" style={{ "margin-top": "8px" }}><For each={navigation}>{(item) => <button class={`nav-item ${props.view === item.view ? "active" : ""}`} type="button" onClick={() => navigate(item.view)}><StreetIcon name={item.icon} /> {item.label}</button>}</For></div>
          <div class="nav-spacer" />
          <button class="help-btn" type="button" onClick={props.onHelp}><StreetIcon name="lifering" size={18} /> Ich brauche Hilfe</button>
          <div class="user-card"><div class="user-name">{props.user.firstName} {props.user.lastName}</div><div class="user-role"><StreetIcon name="smiley" size={14} /> Schüler</div><button class="nav-item" type="button" style={{ "margin-top": "8px", padding: "6px", "font-size": "0.8rem" }} onClick={props.onLogout}><StreetIcon name="logout" size={18} /> Abmelden</button></div>
        </aside>
        <main class="main-content"><div class="fade-in">{props.children}</div></main>
      </div>
    </>
  );
}
